<div class="user-management">
  @if (isLoading$ | async) {
    <div class="policy-spinner">
      <mat-progress-spinner class="loading-spinner" color="primary" mode="indeterminate"></mat-progress-spinner>
    </div>
  } @else {
    <div class="user-management-tabs-section">
      <div class="tabs-titles">
        @if (tabs.length > 0) {
          <app-sidepanel-tabs [tabs]="tabs" (tabOnSelection)="onTabSelect($event)"></app-sidepanel-tabs>
        }
      </div>
      <div class="divider"></div>
    </div>

    <div class="scollable-tables">
      @switch (currentTabIndex) {
        @case (0) {
          @if (featureFlagsService.isFeatureEnabled(featureFlagTypes.rbacAccessManagement)) {
            <app-users></app-users>
          } @else {
            <app-users-legacy></app-users-legacy>
          }
        }
        @case (1) {
          <app-account-apis></app-account-apis>
        }
        @case (2) {
          <app-audit-log-events></app-audit-log-events>
        }
        @case (3) {
          @if (featureFlagsService.isFeatureEnabled(featureFlagTypes.rbacAccessManagement)) {
            <app-access-groups></app-access-groups>
          }
        }
      }
    </div>
  }
</div>
